module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/icon_arrow_white-48ba79d676db7a6a49ceb18ba2d98fbc.svg";